myApp.filter("matchMedia", function($window) {
    return function matchMedia(mediaQueryString) {
        return $window.matchMedia(mediaQueryString).matches;
    }
});
